<template>
  <div id="training" v-show="rankList.length > 0" class="sw-speed-reading-book">
    <div class="speed-select" v-if="$route.query.lxmc === '阅读训练'">
      <ul class="rank" v-for="rank of rankList" :key="rank.djid">
        <li>
          <div class="sw-btn" @click="handleRank(rank)" :class="{ 'active': currentRank === rank.djmc }">
            {{ rank.djmc }}
          </div>
          <transition name="custom-classes-transition" enter-active-class="animated fadeInDown">
            <ul class="speed" v-if="currentRank === rank.djmc">
              <template v-for="(item, index) in speed">
                <li :class="{ 'current-speed': item === selectedSpeed }" :key="index" @click.stop="handleSpeed(item)">
                  {{ item }}
                </li>
              </template>
            </ul>
          </transition>
        </li>
      </ul>
    </div>
    <div class="books-container">
      <ul class="books-store" v-show="rawBooks.length">
        <li class="books-row" v-for="(row, index) in Math.ceil(rawBooks.length / 3)" :key="row">
          <ul>
            <li
                class="book"
                v-for="(book, i) of rawBooks.slice(index * rowNum, index * rowNum + rowNum)"
                :key="book.bookrackId"
                @click="handleSelectBook(book, index * rowNum + i)">
              <img :src="book.sjfm"/>
              <p>{{ book.sjmc }}</p>
            </li>
          </ul>
        </li>
      </ul>
      <div v-if="rawBooks.length === 0" style="text-align:center;line-height:70vh;font-size: 2vw">
        没有更多数据了~~
      </div>
    </div>
    <sw-back-out
        :backPre="`/sw/home?app=${$route.path.substr(4)}&lxid=${$route.query.lxid}&lxmc=${$route.query.lxmc}`"></sw-back-out>
    <div v-if="isLoading" class="sw-loading"></div>
  </div>
</template>

<script>
import {readBooks, readLevel, readLevelDetails} from '@/api/reading';

export default {
  data() {
    return {
      pageSize: 10,
      currentPage: 1,
      total: 0,
      currentRank: '',
      selectedSpeed: '',
      rankList: [],
      speeds: [],
      speed: [],
      rowNum: 3,
      rawBooks: [],
      loadingClass: 'sw-loading',
      emptyText: '',
      isLoading: false,
      flag: false,
      isShowEmptyText: false,
    };
  },
  created() {
    this.fetchRankList();
  },
  methods: {
    async fetchRankList() {
      const {result} = await readLevel();
      this.rankList = result;
      if (this.rankList.length > 0) {
        this.currentRank = this.rankList[0].djmc;
        await this.queryDetail();
        await this.queryBooks();
      }
    },
    async queryBooks() {
      this.isLoading = true;
      const selectedRank = this.rankList.find(rank => rank.djmc === this.currentRank);
      const {result: {list}, resultCode} = await readBooks({
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        lxid: this.$route.query.lxid,
        djid: selectedRank.djid,
      });
      if (resultCode === 200) {
        this.rawBooks = list;
        this.isLoading = false;
        console.log(this.rawBooks);
      }
    },
    async queryDetail() {
      const selectedRank = this.rankList.find(rank => rank.djmc === this.currentRank);
      if (selectedRank) {
        const {result: {djqj}} = await readLevelDetails({
          djid: selectedRank.djid,
        });
        this.speed = djqj;
        this.selectedSpeed = this.speed[0];
      }
    },
    handleRank(rank) {
      this.currentRank = rank.djmc;
      this.queryDetail();
      this.queryBooks();
    },
    handleSpeed(item) {
      console.log(item, '666');
      this.selectedSpeed = item;
    },
    handleSelectBook(book, i) {
      this.$store.commit('speedReading/setBook', book);
      this.$store.commit('speedReading/setSpeed', this.selectedSpeed);
      localStorage.setItem('book', JSON.stringify(book));
      localStorage.setItem('selectedSpeed', JSON.stringify(this.selectedSpeed));
      const {lxmc} = this.$route.query;
      if (lxmc === '能力测试' || lxmc === '阅读训练' || lxmc === '必读书籍') {
        this.$router.push({
          path: lxmc === '必读书籍' ? 'selectChapter' : 'reading',
          query: {
            lxid: this.$route.query.lxid,
            lxmc: this.$route.query.lxmc,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>

$speedWidth: 26vw;
#training {
  $imgWidth: calc((100vh) / 5.8);
  width: 100vw;
  height: 100vh;
  display: flex;
  //.pager {
  //  padding-top: 20px;
  //  text-align: right;
  //}
  .speed-select {
    width: $speedWidth;
    overflow: hidden;
    overflow-y: auto;

    /* Custom scrollbar styling */
    &::-webkit-scrollbar {
      width: 8px; /* Width of the scrollbar */
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1; /* Background of the scrollbar track */
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: rgba(220, 218, 218, 0.97); /* Scrollbar color */
      border-radius: 10px;
      border: 2px solid #f1f1f1; /* Optional: adds a border around the scrollbar thumb */
    }

    &::-webkit-scrollbar-thumb:hover {
      background-color: #555; /* Color of the scrollbar on hover */
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        text-align: center;
        cursor: pointer;
      }
    }

    ul.rank {
      text-align: right;
      margin-top: 25px;
      & > li {
        .sw-btn {
          padding-top:1.5vh ;
          padding-bottom: 1.5vh;
          margin: 0;
          font-size: 1.5vw;
          opacity: .7;

          &.active {
            opacity: 1;
          }
        }

        ul.speed {
          background: #fff;
          margin: 10px auto;
          border-radius: 10px;
          width: 10vw;
          height: 5vh;
          li {
            line-height: 5vh;
            font-size: 1vw;
            cursor: pointer;

            &.current-speed {
              color: #5299d0;
            }
          }
        }

        .fade-enter-active {
          opacity: 1;
          transform: scaleY(1);
          transform-origin: center top;
        }

        .fade-enter,
        .fade-leave-active {
          opacity: 0;
          transform: scaleY(0);
        }
      }
    }

    .sw-button {
      position: absolute;
      right: 2vw;
      bottom: 0;
    }
  }

  .books-container {
    width:100%;
    padding: 6vh 6vw 1vh 5vw;
    overflow: hidden;
    overflow-y: auto;
    height: calc(100vh - 6vh) !important;

    ul.books-store {
      li.books-row {
        margin: 0 0 4vh;

        ul {
          margin-bottom: 2vh;
        }

        .book {
          img {
            width: $imgWidth;
            height: calc(#{$imgWidth} * 1.3);
          }

          // box-shadow: -6px 0 0 2px #999, 0 3px 3px 2px #999;
        }
      }
    }

    .sw-empty-text {
      height: 100%;
    }
  }
}
</style>
